import React from 'react';

import MemberEditForm from '@components/form/MemberEditForm';

interface Props {
  memberId: string;
}

const MemberUpdateForm = ({memberId}: Props): JSX.Element => <MemberEditForm memberId={memberId} locked />;

export default React.memo(MemberUpdateForm);
